// ============================================================
// 🔐 auth.js – Gestion de l’authentification et fetch sécurisé
// ============================================================

import { messageErreurHttp } from "./reponseHttp";

// ⛔ Blocker 2 : plus de token admin baké au build (VITE_ADMIN_API_TOKEN).
//    Un secret injecté dans le bundle statique est lisible par tout client.
//    L'authentification repose désormais uniquement sur l'access_token runtime
//    obtenu via le login backend.

/** Récupère le token brut (access_token runtime uniquement) */
export function getToken() {
  return localStorage.getItem("access_token");
}

/** Construit les headers d’auth */
export function getAuthHeaders() {
  const token = getToken();

  if (!token) {
    console.warn("⚠️ Aucun access_token disponible (login requis).");
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

/** Fetch sécurisé avec headers d’auth + gestion d’erreurs */
export async function secureFetch(url, options = {}) {
  const headers = { ...(options.headers || {}), ...getAuthHeaders() };
  const resp = await fetch(url, { ...options, headers, credentials: "include" });

  // ⚠️ DEUX modes d'échec, pas un seul — mesurés en production le 2026-08-07.
  //
  //    1. Statut non-2xx : le cas historique, déjà traité ici.
  //    2. `200 text/html` : sur un hôte qui sert l'interface mais ne route pas
  //       la surface API visée, nginx répond par le repli SPA. `resp.ok` vaut
  //       alors TRUE, la réponse passait, et c'est `res.json()` qui cassait
  //       chez l'appelant sur un « Unexpected token '<' » illisible.
  //
  //    Le message porte désormais la cause. Il était `HTTP 405` : exact, mais
  //    inexploitable sans ouvrir la console du navigateur — ce qui est
  //    précisément ce qu'on demande à l'utilisateur d'éviter.
  const replISpa = (resp.headers.get("content-type") || "").includes("text/html");
  if (!resp.ok || replISpa) {
    console.error(`❌ Erreur HTTP ${resp.status} sur ${url}`);
    const err = new Error(messageErreurHttp(resp, url));
    // `status` et `reponse` permettent à l'appelant de décider (ex. 401 →
    // redirection login) sans avoir à analyser la chaîne du message.
    err.status = resp.status;
    err.reponse = resp;
    throw err;
  }
  return resp;
}
